import { NgModule } from '@angular/core';
import { CompanyListScreenComponent } from './company-list.screen.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  declarations: [CompanyListScreenComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    TranslateModule,
    ComponentsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatTableModule,
    RouterModule.forChild([
      {
        path: '',
        component: CompanyListScreenComponent,
      },
    ]),
  ],
})
export class CompanyListScreenModule {}
